<script lang="ts">
  import { store } from '../lib/stores.svelte.js';
</script>

{#if store.glossaryOpen}
  <div class="overlay" onclick={(e) => { if (e.target === e.currentTarget) store.glossaryOpen = false; }} role="presentation">
    <div class="panel">
      <header>
        <h2>Glossary & Methodology</h2>
        <button class="close" onclick={() => (store.glossaryOpen = false)}>×</button>
      </header>

      <section>
        <h3>Core Metrics</h3>
        <dl>
          <dt>GPIv</dt>
          <dd>Growth Performance Index value. Slope of the 8-week rolling GMV regression. Positive = growing, negative = declining. Units: ₱/week change.</dd>

          <dt>GPIv Tier</dt>
          <dd>Categorical bucket from per-period Slope percentiles. <strong>v1.1 recomputes thresholds each period</strong>, so the same city's tier can shift across periods even if its slope is unchanged.</dd>

          <dt>Size of Prize (SoP)</dt>
          <dd>Estimated untapped revenue opportunity per city. Formula: <code>Category GMV × max(slope, 0) × (1 − share × 0.85)</code>. The 0.85 dampener ensures a residual 15% SoP at 100% share when the category is growing — promo investment can expand the pie. Zero when the category is declining.</dd>

          <dt>My GMV / Cat GMV / My Share</dt>
          <dd>My GMV: 8-week revenue of the filtered SKU subset. Cat GMV: 8-week revenue across ALL SKUs in the same product_type. Share = my / cat.</dd>
        </dl>
      </section>

      <section>
        <h3>City Context (Coochara V2)</h3>
        <dl>
          <dt>Market Potential</dt>
          <dd>0–100 city attractiveness score. Weighted percentile rank: Population 30%, Income per Capita 25%, Business Growth YoY 20%, Housing Units 15%, New Businesses 10%.</dd>

          <dt>Consumer Profile</dt>
          <dd>Priority-ordered tags from city quantiles: Premium → Young → Growing → Value → Mainstream (fallback). Cities can carry multiple tags.</dd>
        </dl>
      </section>

      <section>
        <h3>Period Slicer</h3>
        <p>The slicer iterates monthly snapshots of the regression layer (VersionDate). Filters are preserved across period changes; if a combination has no data in the new period, the table will show empty and the map will be sparse.</p>
      </section>

      <footer>
        <small>PACK001 · Cube semantic layer + Coochara V2 demographics</small>
      </footer>
    </div>
  </div>
{/if}

<style>
  .overlay {
    position: fixed; inset: 0;
    background: rgba(13, 46, 74, 0.45);
    z-index: var(--z-modal);
    display: flex; align-items: center; justify-content: center;
    padding: var(--space-xl);
  }
  .panel {
    background: var(--color-white);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-modal);
    width: min(720px, 100%);
    max-height: 90vh;
    overflow-y: auto;
    padding: var(--space-xl);
    font-family: var(--font-body);
    color: var(--color-text);
  }
  header { display: flex; align-items: center; justify-content: space-between; margin-bottom: var(--space-lg); }
  h2 { margin: 0; font-family: var(--font-display); font-size: var(--text-2xl); text-transform: uppercase; color: var(--color-navy); }
  .close { background: transparent; border: none; font-size: var(--text-xl); cursor: pointer; color: var(--color-text-muted); }
  section { margin-bottom: var(--space-lg); }
  h3 { margin: 0 0 var(--space-sm); font-family: var(--font-display); font-size: var(--text-md); text-transform: uppercase; color: var(--color-blue); }
  dl { display: grid; grid-template-columns: 1fr 2fr; gap: var(--space-sm) var(--space-md); margin: 0; }
  dt { font-weight: var(--weight-semibold); color: var(--color-navy); }
  dd { margin: 0; }
  code { font-family: var(--font-mono); background: var(--color-surface); padding: 1px 6px; border-radius: var(--radius-sm); font-size: 90%; }
  footer { font-family: var(--font-ui); color: var(--color-text-muted); border-top: 1px solid var(--color-border); padding-top: var(--space-md); }
</style>
